import { bankApi, individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async initMyAccount({ commit, dispatch }) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchBalance'),
      dispatch('fetchAccount'),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchBalance({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await bankApi.requestBalance(token);
      commit('setBalance', response.data.balance);
    }
    catch (error) {
      if (error.response?.status === 404) {
        commit('setBalance', []);
      }
      else {
        commit('setError', error);
      }
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchAccount({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestMyAccount(token);
      commit('setAccount', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
